import React from 'react';
import properties from '../../modules/ajio-util/properties';

export default class BestPriceSectionInfo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="best-price-section">
        <div className="info-icon-best-price">
          <img src={`${properties.getProperty('imageBaseUrl')}/static/img/information.svg`} alt='Information icon'/>
        </div>
        <div className="best-price-section-heading">Best Price - Grab now!</div>
        <div className="best-price-section-subheading">
          Price highlighted in blue indicates this product is available at its best price & no
          coupons are applicable.
        </div>
      </div>
    );
  }
}
